import React from 'react'
import { Dropdown } from 'primereact/dropdown'
import { isNonEligibleContributionType, isNonEligibleContributor, ContributionTypeIds } from 'modules/Constants'

const ContributionTypesDropdownEditor = ({ options, contributionTypes, validationErrors, editorCallbacksRef, dataKey, contactTypeIds, contributionTypeIds }) => {
    const { rowIndex, rowData, editorCallback } = options
    const rowKey = rowData[dataKey]
    
    // Filter contribution types based on contact type
    let selectableTypes = contributionTypes?.filter(ct => ct.isSelectable) || []
    
    // If contact is Non-Eligible Contributor, only show Actor and Director
    if (isNonEligibleContributor(rowData.contactTypeId)) {
        selectableTypes = selectableTypes.filter(ct => 
            ct.id === ContributionTypeIds.Actor || ct.id === ContributionTypeIds.Director
        )
    }

    const handleChange = (e) => {
        const selected = e.value
        rowData.contributionType = selected
        rowData.contributionTypeId = selected.id

        const isActorOrDirector = isNonEligibleContributionType(selected)
        
        // For Actor or Director contribution types, ALWAYS set to 0 (regardless of contact type)
        if (isActorOrDirector) {
            rowData.percentage = 0
            rowData.minutes = 0
        }

        // Notify percentage/minutes editors of contribution type change
        const callbacks = editorCallbacksRef?.current
        callbacks?.setPercentageContributionType?.[rowKey]?.(selected)
        callbacks?.setMinutesContributionType?.[rowKey]?.(selected)
        
        if (isActorOrDirector) {
            callbacks?.percentage?.[rowKey]?.(0)
            callbacks?.minutes?.[rowKey]?.(0)
        } else {
            callbacks?.percentage?.[rowKey]?.(rowData.percentage)
            callbacks?.minutes?.[rowKey]?.(rowData.minutes)
        }

        editorCallback(selected)
    }

    return (
        <Dropdown
            value={selectableTypes.find(ct => ct.id === rowData.contributionTypeId) || null}
            options={selectableTypes}
            onChange={handleChange}
            optionLabel="name"
            placeholder="Select Type"
            filter
            className={validationErrors[rowIndex]?.[options.field] ? 'p-invalid' : ''}
        />
    )
}

export default ContributionTypesDropdownEditor
